import {
  pageMoveAnkerFunc,
} from "./common/_pageLinkAnimation";
import {
  idxFunc,
} from "./pages/_index";
//* ----------------------------------------
//window実行
//--------------------------------------- */
////// ロード時
$(window).on('load', function () {
  idxFunc();
  pageMoveAnkerFunc();
});